var ThemeName;
(function (ThemeName) {
    ThemeName["lager"] = "lager";
    ThemeName["guinness"] = "guinness";
})(ThemeName || (ThemeName = {}));
var AvitoThemeName;
(function (AvitoThemeName) {
    AvitoThemeName["avitoLight"] = "avito-light";
})(AvitoThemeName || (AvitoThemeName = {}));

export { AvitoThemeName, ThemeName };
//# sourceMappingURL=index.js.map
